/*
 * @Descripttion: 
 * @version: 
 * @Author: leon
 * @email: leon0023@zoho.com.cn
 * @Date: 2022-08-23 14:04:34
 * @LastEditors: K
 * @LastEditTime: 2022-08-26 10:28:04
 */
import React, { ReactElement, useContext, useEffect, useState } from 'react';

import { Button, Form, Input, Row, Space, Cascader as Cascaded, Select, } from 'antd';

import { CaretDownFilled, SearchOutlined } from '@ant-design/icons';
import { stringTrim } from '../../../utils/StringUtils';
import { unwrapResult } from '@reduxjs/toolkit';
import { useDispatch } from 'react-redux';
import { RootDispatch } from '../../../app/store';
import { getAllList } from '../../tenant/tenantSlice';
import { ThemeContext } from '../../../theme/ThemeContext';
import { getPlatformTypeName, getTeantTypeName, getTenantCategoryName, platformTypes, teantTypes, TenantCategories } from '../../../models/tenant';

interface queryProps {
  onSubmit: (obj: any) => void
}
export const Query = ({
  onSubmit
}: queryProps): ReactElement => {

  const dispatch = useDispatch<RootDispatch>()

  const [form] = Form.useForm()

  const theme = useContext(ThemeContext)

  const [allList, setAllList] = useState<any[]>()   //省市数据

  const loadData = (selectedOptions: any) => {
    const targetOption = selectedOptions[selectedOptions.length - 1]
    targetOption.loading = true
  }

  useEffect(() => {   //获取省市数据
    dispatch(getAllList())
      .then(unwrapResult)
      .then((t: any) => {
        setAllList(t)
      })
  }, [])
  return (
    <div>
      {/* 筛选查询区域 */}
      <Form
        form={form}
        autoComplete='off'
        onFinish={(values) => {
          console.log(values, '123');

          onSubmit({
            ...values,
            tenantCategory: values.tenantCategory == 0 ? undefined : values.tenantCategory,
            area: undefined,
            provinceCode: values?.area?.slice(0, 1)[0],
            cityCode: values?.area?.slice(1, 2)[0],
            countyCode: values?.area?.slice(2, 3)[0],
          })

        }}
      >
        <Row
          justify='space-between'
          align='middle'
        // className={styles.queryWrap}
        >
          <Space>
            <Form.Item name='name' noStyle getValueFromEvent={stringTrim}>
              <Input
                allowClear
                placeholder='请输入机构名称'
                prefix={<SearchOutlined />}

                onChange={form.submit}
              />
            </Form.Item>
            <Form.Item name='tenantCategory' noStyle>
              <Select
                placeholder='机构类别-全部'
                style={{ width: '9rem' }}
                onChange={form.submit}
                allowClear
              >
                {TenantCategories?.map((el: any) => (
                  <Select.Option key={el} value={el}>
                    机构类别-{getTenantCategoryName(el)}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
            <Form.Item name='tenantType' noStyle>
              <Select
                placeholder='请选择机构类型'
                onChange={form.submit}
                style={{ width: '9rem' }}
                allowClear
              >
                {teantTypes.map((el: any) => (

                  <Select.Option key={el} value={el}>
                    机构类型-{getTeantTypeName(el)}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
            <Form.Item name='platformType' noStyle>
              <Select
                placeholder='请选择合作平台'
                style={{ width: '9rem' }}
                onChange={form.submit}
                allowClear
              >
                {platformTypes?.map((el: any) => (
                  <Select.Option key={el} value={el}>
                    {getPlatformTypeName(el)}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
            <Form.Item name='area' noStyle>
              <Cascaded
                loadData={loadData}
                changeOnSelect
                suffixIcon={<CaretDownFilled style={{ color: theme.tc3 }} />}
                options={allList}
                style={{ width: '13rem' }}
                onChange={form.submit}
                placeholder='请选择省市区'
              />
            </Form.Item>
            <Form.Item name='insuranceStatus' noStyle>
              <Select
                placeholder='是否接入医保'
                style={{ width: '8rem' }}
                onChange={form.submit}
                allowClear
              >
                <Select.Option value={1}>是</Select.Option>
                <Select.Option value={0}>否</Select.Option>
              </Select>
            </Form.Item>
          </Space>
          <Button type='primary' htmlType='submit'>
            查询
          </Button>
        </Row>
      </Form>
    </div>
  );
}

